import { useRef, useCallback } from 'react';
import { OverlayPanel } from 'primereact/overlaypanel';
import { useStore } from 'hooks/useStore';
import { useNavigate } from 'react-router-dom';

export const useMenuPopover = () => {
  const {
    NavbarStore: { isNavigationRestricted },
  } = useStore();
  const navigate = useNavigate();

  // Define the ref type
  const op = useRef<OverlayPanel | null>(null);

  const handleMenuClick = useCallback((e: React.MouseEvent) => {
    e.stopPropagation(); // Prevent event bubbling
    if (op.current) {
      (op.current as any).toggle(e); // Call the `toggle` method if it exists
    }
  }, []);

  const handleNavigation = useCallback(
    (route: string) => {
      if (isNavigationRestricted) {
        if (window.confirm('Are you sure want to navigate??')) {
          navigate(route);
        }
      } else {
        navigate(route);
      }
    },
    [isNavigationRestricted, navigate]
  );

  return { op, handleMenuClick, handleNavigation };
};
